import { IOptions } from "components/shared/form/SelectField";

export const writeOffTypeOptions: IOptions[] = [
  {
    value: 'REPOSSESS',
    label: 'Repossess',
  },
  {
    value: 'CLEAR',
    label: 'Clear',
  },
]

export const conditionOptions: IOptions[] = [
  {
    value: 'NEW',
    label: 'New',
  },
  {
    value: 'USED',
    label: 'Used',
  },
]